<template>
  <div class="money-component">
    <template v-if="isPrefix">
      <span class="symbol">{{ symbol }}</span>
      <span class="formattedMoney">{{ formattedMoney }}</span>
    </template>

    <template v-else>
      <span class="formattedMoney">{{ formattedMoney }}</span>
      <span class="symbol">{{ symbol }}</span>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  money: number | string;
  currency: string;
  style: 'CM' | 'MC' | 'CMF' | 'CMB';
}

const props = withDefaults(defineProps<Props>(), {
  money: 0,
  currency: 'USD',
  style: 'CMF',
});

// format tiền
const formattedMoney = computed(() => {
    let currencyFormat = 'en-US'
    if(props.currency == 'VND') {
        currencyFormat = 'vi-VN'
    }
      return new Intl.NumberFormat(currencyFormat).format(Number(props.money));

//   return new Intl.NumberFormat(currencyFormat, {
//     style: 'currency',
//     currency: props.currency,
//   }).format(Number(props.money));
});

// ký hiệu tiền
const symbol = computed(() => {
  if (props.style === 'CMF' || props.style === 'CMB') {
    return '$';
  }
  return props.currency;
});

// vị trí ký hiệu
const isPrefix = computed(() => {
  return props.style === 'CM' || props.style === 'CMF';
});
</script>
<style lang="css" scoped>
.money-component .symbol {
    padding-left: 5px;
    padding-right: 5px;
}
</style>